/**
 * Handle ID constants for ReactFlow node connections
 * 
 * These constants define the connection points on flow nodes:
 * - RIGHT: Standard output handle (creates forward flow)
 * - LEFT: Standard input handle (receives connections)
 * - LEFT_SOURCE: Special output handle for backward connections
 */
export const HANDLE_IDS = {
  /** Right-side handle for standard forward connections */
  RIGHT: 'right',

  /** Left-side handle for receiving connections (target) */
  LEFT: 'left',

  /** Left-side handle for creating backward connections (source) */
  LEFT_SOURCE: 'left-source',
} as const;

export type HandleId = (typeof HANDLE_IDS)[keyof typeof HANDLE_IDS];
